import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import logo1 from "../../assets/AboutUs/Logos/1655947287633341.jpg";
import logo2 from "../../assets/AboutUs/Logos/1655947280589836.jpg";
import logo3 from "../../assets/AboutUs/Logos/1655947273704860.jpg";
import logo4 from "../../assets/AboutUs/Logos/1655947268102067.jpg"
import logo5 from "../../assets/AboutUs/Logos/1655947261626112.jpg"
import logo6 from "../../assets/AboutUs/Logos/1655947257134371.jpg"

const darkLogos = [
  // logo1,
  // logo2,
  logo3,
  logo4,
  logo5,
  logo6,
  logo2,
  logo1
];

const logoStyle = {
  width: "240px",
  height: "129px",
  margin: "0 5px",
  border: "1px solid black",
  padding: "0 4px",
  marginBottom: "25px",
};

export default function LogoCollection() {
  return (
    <Box id="logoCollection" sx={{ py: 10 }}>
      <Typography
        component="p"
        variant="subtitle2"
        align="center"
        // color="text.secondary"
        sx={{
          fontSize: { xs: "3rem", sm: "3rem" },
        }}
      >
        COOPERATIVE PARTNER
      </Typography>
      <Typography
    component="p"
    variant="subtitle2"
    align="center"
    color="text.secondary" // Set the color for the subheading
    sx={{
      fontSize: { xs: "1.5rem", sm: "1.5rem",marginBottom:50 }, // Adjust font size for different screen sizes
    }}
  >
    Develop long-term and reliable cooperative relations
  </Typography>
      
      <Grid container justifyContent="center" sx={{ mt: 0.5 }}>
        {darkLogos.map((logo, index) => (
          <Grid item key={index}>
            <img
              src={logo}
              alt={`Fake company number ${index + 1}`}
              style={logoStyle}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
